import { render, staticRenderFns } from "./IconRental.vue?vue&type=template&id=56144c7a"
import script from "./IconRental.vue?vue&type=script&lang=js"
export * from "./IconRental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports